import React, { useImperativeHandle, useRef, useCallback, useState, useEffect } from 'react';
import overlaySVG from '../../../images/svg/region-caches/zec-bsl.svg';
import { ValideCoordinateCache } from "./valideCoordinateCache";
import { getCache, sauvegarderCache } from "../../server/services/cache-service";
import { Map, AdvancedMarker, useMap } from "@vis.gl/react-google-maps";

const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function resolveIdCache(propId) {
  const el = typeof document !== 'undefined' ? document.getElementById('idCache') : null;
  const hiddenValue = el?.value?.trim();
  if (hiddenValue) return hiddenValue;

  const p = (propId || '').trim();
  return p || '';
}

function mergeGpsFieldsIntoCache(existing, latitude, longitude) {
  return {
    ...existing,
    latDeg: Number.parseInt(document.getElementById('Lat').value, 10) || 0,
    latMin: Number.parseInt(document.getElementById('LatMin').value, 10) || 0,
    latSec: Number.parseFloat(document.getElementById('LatSec').value) || 0,
    latDegDec: latitude,
    longDeg: Number.parseInt(document.getElementById('Lon').value, 10) || 0,
    longMin: Number.parseInt(document.getElementById('LonMin').value, 10) || 0,
    longSec: Number.parseFloat(document.getElementById('LonSec').value) || 0,
    longDegDec: Math.abs(longitude),
    longDegDecNeg: longitude
  };
}

const geo = require('./mapgeo.json')

const containerStyle = {
  width: '100%', height: '100vh',
};

const libraries = ['places'];
const label = { text: `Nouvelle cache`, color: '#FFEF00' };

const MapComponent = React.forwardRef((props, ref) => {
  const [markers, setMarkers] = useState([]);
  const map = useMap()

  useImperativeHandle(ref, (value) => ({
    validateMarker(value) {
      handlevalidateMarker(value);
    },
    coordinateChanged(lat, lng) {
      setMarkers([{ lat: Number(lat), lng: Number(lng) }])
    }
  }));

  const { coordinatesZEC } = props

  function handlevalidateMarker(verifier) {

    let latitude = Number(document.getElementById('Latitude').value);
    let longitude = Number(document.getElementById('Longitude').value);

    if (map) {
      setMarkers(prevMarkers => {
        return [{ lat: Number(latitude), lng: Number(longitude) }]
      });
    }

    if (verifier === 1) {

      const [coordinateOk, message] = ValideCoordinateCache(latitude, longitude);
      if (coordinateOk) {
        const idCache = resolveIdCache(props.idCache);
        // if (!GUID_RE.test(idCache)) {
        //     alert('Identifiant de cache (idCache) manquant ou invalide. Utilisez ?idCache=VOTRE_GUID dans l’URL ou renseignez le champ caché idCache.');
        //     return;
        // }
        if (!idCache) {
          alert('Identifiant de cache (idCache) manquant ou invalide.');
          return;
        }

        void (async () => {
          try {
            if (!props?.currentCache?.idCache || !props.idClient) {
              alert('Informations de cache incomplètes. Sélectionnez une cache et réessayez.');
              return;
            }

            const base = {
              ...props.currentCache,
              idClient: props.idClient,
              idUsagerCreation: props.idClient,
              idUsagerModification: props.idClient,
            };

            const payload = mergeGpsFieldsIntoCache(base, latitude, longitude);
            const res = await sauvegarderCache(payload, props.idZec, props.authToken);
            if (res.status === 401) {
              alert('Vous devez être connecté pour enregistrer les coordonnées.');
              return;
            }
            if (!res.ok) {
              let detail = '';
              try {
                detail = await res.text();
              } catch (e) {
                // console.log(e);
              }
              alert(detail || 'Erreur lors de la sauvegarde.');
              return;
            }
            alert('PARFAIT');
          } catch (e) {
            // console.log(e);
            alert('Erreur lors de la sauvegarde des coordonnées.');
          }
        })();
      } else {
        //alert(message);
        alert(message);
      }
    }

  }

  useEffect(() => {
    if (!map) return;

    const bounds = new window.google.maps.LatLngBounds(new window.google.maps.LatLng(coordinatesZEC.minLat, coordinatesZEC.minLng), new window.google.maps.LatLng(coordinatesZEC.maxLat, coordinatesZEC.maxLng));

    map.fitBounds(bounds);
    const features = map.data.addGeoJson(geo)

    map.data.setStyle({ fillColor: "#3DFF00", fillOpacity: 0.3, strokeColor: "#3DFF00", strokeWeight: 1, clickable: false })

    return () => {
      features.forEach(f => map.data.remove(f))
    }
  }, [map, coordinatesZEC])

  const onMapClick = useCallback((event) => {
    const latLng = event.detail.latLng;
    if (!latLng) return;

    const lat = Number(latLng.lat);
    const lng = Number(latLng.lng);
    setMarkers([{ lat, lng }]);

    props.newClickSurLaCarte(lat.toFixed(4), lng.toFixed(4));
  }, [props.newClickSurLaCarte]);

  if (coordinatesZEC.center.lat === 0) return <></>

  return (<Map
    style={containerStyle}
    zoomControl={true}
    defaultCenter={coordinatesZEC.center}
    defaultZoom={13}
    mapId={"DEMO_MAP_ID"}
    mapTypeId={'hybrid'}
    onClick={onMapClick}
    onMapTypeIdChanged={(e) => console.log(e)}
  >
    {markers.map((marker, index) => {
      return (<AdvancedMarker key={index} position={marker} title={props.markerTitle || 'Nouvelle cache'} />

      );
    })}

  </Map>

  )
})

export default MapComponent;
